import React, {useEffect, useState} from 'react'
import { Table, Button } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import ReactHTMLTableToExcel from 'react-html-table-to-excel'
import axios from 'axios'
import { useSelector } from 'react-redux'

const IzvestajiScreen = () => {

  const [kvarovi, setKvarovi] = useState([])
  const [mesta, setMesta] = useState([])
  const [mesto, setMesto] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [status, setStatus] = useState(true)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (mesto) {
      axios.get(`/api/stubovi/izvestaji/${mesto._id}`).then(item => {
        setKvarovi(item.data)
      })
    }
    
  }, [mesto])
  const OkHandler = (kvar) => {
    
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
     axios.put(`/api/status/${kvar.stub._id}`, {status}, config).then((i)=>{
      console.log(i.data)
      setKvarovi(kvarovi.filter((item)=>item.stub._id !== i.data._id))
    console.log(kvarovi)}
     )
     
     
    }
  
  const searchHandler = (query) => {
    setIsLoading(true)
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token} `
      }
    }

    axios.get(`/api/mesta/?abr=${query}`, config).then(item => {
      setMesta(item.data)
      setIsLoading(false)
      
    })

  } 


  const filterBy = () => true

  return (
    <>
      <h1>Izvestaj o kvarovima</h1>
      {!mesto && 
      <AsyncTypeahead 
      filterBy={filterBy}
      id='basic-example' 
      labelKey='naziv'
      isLoading={isLoading}
      minLength={3}
      onSearch={searchHandler}
      options={mesta}
      placeholder='Izaberi grad'
      renderMenuItemChildren={(mesto) => (
        <div onClick={() => {
          setMesto(mesto)
          //setIsLoader(true)
        }}>
        <span>{mesto.naziv}</span>
        </div>
        
      )}
      />}
       {mesto && 
       <>
       <Button onClick={()=>setMesto(null)} variant='outline-success'  className='btn-sm my-3' >
                 Nazad
               </Button>
       <Table id='table-to-xls' striped bordered hover responsive className='table-sm'>
         <thead>
           <tr>
             <th>Redni broj</th>
             <th>Svetiljka</th>
             <th>Adresa</th>
             <th>Snaga</th>
             <th>Lat</th>
             <th>Lon</th>
             <th>Datum</th>
             <th>Email</th>
             <th>Opis kvara</th>
           </tr>
         </thead>
         <tbody>
           {kvarovi.map(kvar => (
             <tr key={kvar._id}>
               <td>{kvar.stub.Rbr}</td>
               <td>
                 {kvar.stub.svetiljka}
                 </td>
               <td>
                {kvar.stub.Adresa}
               </td>
               <td>{kvar.stub.snaga}</td>
               <td>{Number(kvar.stub.LAT)}</td>
               <td>{kvar.stub.LON}</td>
               <td>{kvar.datum.slice(0,10)}</td>
               <td>{kvar.email}</td>
               <td>{kvar.opisK}</td>
               <td>
               
                 <Button onClick={()=>OkHandler(kvar)} variant='outline-success' className='btn-sm'>
                   OK
                 </Button>
               
               </td>
             </tr>
           ))}
         </tbody>
       </Table>
       <ReactHTMLTableToExcel 
       id='test-table-xls-button'
       className='download-table-xls-button btn btn-outline-success'
       table='table-to-xls'
       filename='izvestaji'
       sheet='izvestaji'
       buttonText='Preuzmi kao Xls'
        />
        </>}
       {/* <Paginate pages={pages} page={page} isAdmin={true}/> */}
       
    </>
  )
}

export default IzvestajiScreen
